// extracted by css-extract-rspack-plugin
export default {"root":"D3hkn","bodyCellWithImage":"jlIkS","pivotedFirstColumn":"Ov8ag","highlightedCell":"zwVLm","dimmedCell":"IH0_a"};